import { deleteExpense, deleteIncome, type LedgerResult } from '../../../ledger/ledger';
import { reverseCardPayment, reverseDebtPayment } from '../../../ledger/reversals';
import { reopenCancelled } from '../../../ledger/plans';
import type { PlannedEntry } from './plannedEntries';

const COLLECTION = { expense: 'plannedExpenses', income: 'plannedIncomes', payment: 'plannedPayments' } as const;

/** Mở lại khoản đã bỏ qua nhầm → về lại danh sách chờ xác nhận. */
export const reopenSkipped = (uid: string, e: PlannedEntry): Promise<LedgerResult> => reopenCancelled(uid, COLLECTION[e.kind], e.id);

export interface UndoDialog { title: string; description: string; confirmLabel: string }

/** Nội dung hộp xác nhận hoàn tác một khoản đã xác nhận; { blocked } = không hoàn tác được (kèm lý do). */
export const undoDialog = (e: PlannedEntry): UndoDialog | { blocked: string } => {
  const d = e.doc;
  const id = e.kind === 'payment' ? d.actualPaymentId : e.kind === 'income' ? d.actualIncomeId : d.actualExpenseId;
  if (!id) return { blocked: 'Khoản này không còn liên kết tới giao dịch đã ghi (dữ liệu cũ). Hãy tìm và xoá giao dịch ở mục Giao dịch, hoặc mở lại ở Cài đặt › Kiểm tra toàn vẹn.' };
  if (e.kind === 'payment') {
    return { title: `Hoàn tác "${e.title}"?`, description: 'Tiền hoàn lại ví đã trả, dư nợ thẻ/khoản vay tăng lại đúng số đã trả (khoản chi lãi tự sinh bị xoá). Khoản dự kiến trở về trạng thái chờ xác nhận. Với khoản vay, chỉ hoàn tác được lần trả mới nhất.', confirmLabel: 'Hoàn tác' };
  }
  return { title: `Hoàn tác "${e.title}"?`, description: `Giao dịch ${e.kind === 'income' ? 'thu' : 'chi'} đã ghi bị xoá, số dư ví được hoàn lại, khoản dự kiến trở về trạng thái chờ xác nhận.`, confirmLabel: 'Hoàn tác' };
};

export const runUndo = (uid: string, e: PlannedEntry): Promise<LedgerResult> => {
  const d = e.doc;
  if (e.kind === 'payment') {
    return d.paymentType === 'debt' ? reverseDebtPayment(uid, d.debtId, d.actualPaymentId) : reverseCardPayment(uid, d.actualPaymentId);
  }
  const link = { reopen: { collection: COLLECTION[e.kind], id: e.id } } as const;
  return e.kind === 'income' ? deleteIncome(uid, d.actualIncomeId, link) : deleteExpense(uid, d.actualExpenseId, link);
};
